import * as $ from "jquery";
import {getWidthByFontSize} from "./utilities";
import * as d3 from "d3";
import {
  fixPosition,
  fixTextPosition,
  removeHashFromUrl,
  skipTags,
  textNodes,
  getParagraphs,
  isTableCell,
  isTable,
  isMultiColumnTable,
  pageLayout,
  getTextOffs,
  setId,
  getTotalSize
} from "./fb2Utilities";

textNodes.push('h1','h2','h3','h4','h5','h6', 'tt', 'blockquote', 'ul', 'guide')
skipTags.push('font', 'br', 'u', 'i', 'b')

export const parseHtml = (data, setPageCount, setPages, setBookReady, onLoadChapters, textFlow, onLoad,
                            onChangeTextSize, textSize, onChangeTextColor, textColor, onChangeTextFont,
                            textFont, onChangeViewMode, findCurrPage, currPage, onSaveReaderPosition,
                            updateReadPosition, bookId, access_token, refresh_token, onAddHighlights,
                            addState) => {
  let parser = new DOMParser();
  let xml = data

  xml = xml.replace(/<image /g, '<img src="" ')
    .replace(/<empty-line\/>/g, '<p class="empty-line"></p>')
    .replace(/<subtitle>/g, '<p class="subtitle">')
    .replace(/<title>/g, '<div class="title">')
    .replace(/<v>/g, '<div class="v">')
    .replace(/<\/v>/g, '</div>')
    .replace(/<title dir="rtl">/g, '<div class="title" dir="rtl">')
    .replace(/<title dir="ltr">/g, '<div class="title" dir="ltr">')
    .replace(/<\/subtitle>/g, '</p>')
    .replace(/<\/title>/g, '</div>')
    .replace(/<mbp:pagebreak\/>/g, '')

  let viewerContent = document.getElementById('viewer-content')
  let viewer = document.getElementById('viewer')
  let xmlDoc = parser.parseFromString(xml,"text/html");

  let readerContent = document.getElementsByClassName('fb2Reader')[0]

  let pages = createPages(xmlDoc)

  setPageCount(pages.pages.length)
  setPages(pages)
  setBookReady(true)

  let xmlPage = document.createElement('div')
  xmlPage.classList.add('xml-page')
  viewerContent.append(xmlPage)
  let noteLayer = document.createElement('div')
  noteLayer.classList.add('noteLayer')
  viewerContent.append(noteLayer)
  let tmp = ''
  onLoadChapters()
  for (let i=0;i<pages.storages.length;i++) {
    let el = pages.storages[i]
    tmp += el.outerHTML
  }

  let textWrap = document.createElement('div')
  textWrap.classList.add('textWrap')
  xmlPage.append(textWrap)
  $(textWrap).html(tmp)

  let pageClass = ''
  switch(textFlow) {
    case '1page':
      pageClass = 'one-page'
      break;
    case '2page':
      pageClass = 'two-page'
      break;
    case 'scrolling':
      pageClass = textFlow
      break;
    default:
      pageClass = ''
  }

  xmlPage.classList = 'xml-page ' + pageClass
  viewerContent.classList = pageClass
  if (readerContent) readerContent.classList = 'fb2Reader ' + pageClass

  viewer.style.maxWidth = ''
  let vWidth = viewerContent.offsetWidth
  if (textFlow !== '2page') {
    vWidth = getWidthByFontSize(textSize)
    viewer.style.maxWidth = vWidth + 'px'
  }

  $('.empty-line').each((i,line) => line.innerText = '')

  let paddingRihgt = 44
  if (textFlow === '2page') {
    let w = vWidth/2 - 88*2
    if (w <= 224) w = vWidth - 66*2
    textWrap.style.columnWidth = w + 'px'
    paddingRihgt = 44
  } else if (textFlow === '1page') {
    textWrap.style.columnWidth = (vWidth - 66*2) + 'px'
    paddingRihgt = 33
  } else {
    textWrap.style.columnWidth = ''
    paddingRihgt = ''
  }
  textWrap.style.width = vWidth + 'px'

  let annotationLayer = document.createElement('div')
  annotationLayer.classList.add('svgWrapper')

  textWrap.style.width = vWidth + 'px'
  let prevW = textWrap.scrollWidth
  let wait = setInterval(() => {
    if (prevW === textWrap.scrollWidth) {
      xmlPage.style.width = textWrap.scrollWidth + paddingRihgt + 'px'
      annotationLayer.style.width = textWrap.scrollWidth + paddingRihgt + 'px'
      noteLayer.style.width = textWrap.scrollWidth + paddingRihgt + 'px'
      clearInterval(wait)
    } else {
      prevW = textWrap.scrollWidth
    }
  }, 500)

  $('.xml-page .textWrap > .title').wrap('<section />')

  viewerContent.append(annotationLayer)
  let svg = d3.select(annotationLayer).append('svg')
  onLoad(svg)

  onChangeTextSize(textSize, true)
  onChangeTextColor(textColor)
  onChangeTextFont(textFont, true)
  onChangeViewMode(textFlow, true)

  let binaries = xmlDoc.getElementsByTagName('binary')
  for (let i=0;i<binaries.length;i++) {
    let binary = binaries[i]
    let id = binary.id
    let imgSrc = binary.innerHTML
    let type = binary.getAttribute('content-type')

    $('#viewer img').each((i, img) => {
      let attributes = img.attributes
      for (let k=0; k<attributes.length;k++) {
        let key = attributes[k].name
        if (key.split(':')[1] === 'href' && $(img).attr(key) === '#' + id) {
          $(img).attr('src', 'data:' + type + ';base64,' + imgSrc)
          $(img).css('max-height', vWidth - 40)
          break;
        }
      }
    })
  }

  $('#viewer .xml-page a').each((i, a) => {
    let attributes = a.attributes
    for (let k=0; k<attributes.length;k++) {
      let key = attributes[k].name
      if (key.split(':')[1] === 'href') {
        $(a).attr('href', $(a).attr(key))
        break;
      }
    }
  })
  $('#viewer .xml-page a').on('click', e => {
    e.preventDefault()
    if (!e.target.getAttribute('href')) return
    if (e.target.getAttribute('href').indexOf('http') > -1) {
      window.location = e.target.getAttribute('href')
      return
    }
    let id = e.target.getAttribute('href').slice(1)
    let el = $('#' + id)
    if (el.length === 0) return
    let section = el.closest('section')
    if (section.is(':visible')) {
      //window.location = '#' + id
      removeHashFromUrl()
    }
    if (section[0] === el[0]) {
      if (el.parent().get(0).tagName.toLowerCase() === 'section') {
        section = el.parent()
      }
    }

    addState()
    fixTextPosition(id, textFlow, null, 'id')
    findCurrPage()
    onSaveReaderPosition()
  })

  setTimeout(() => onAddHighlights(), 1000)
  findCurrPage(true, currPage)
  if (textFlow !== 'scrolling') fixPosition(viewerContent.scrollLeft)
}

export const createPages = (xmlDoc) => {
  let storages = []
  xmlDoc = xmlDoc.children[0].children

  for(let i=0;i<xmlDoc.length;i++) {
    let el = xmlDoc[i]
    if (el.nodeName.toLowerCase() === 'body') {
      storages = storages.concat([].slice.call(el.children))
    }
  }

  let pageLoutVect = []
  let sectionMap = {
    fst_page: 1
  }
  let textOffs = 0
  let firstPar = 0

  let textLeng = -1

  let paragraphs = getParagraphs(storages)
  let pcnt = paragraphs.length
  for (let par=0; par < pcnt; par++) {
    let zltp = paragraphs[par]
    if (pageLoutVect.length > 0) {
      zltp.setAttribute( 'page-num', pageLoutVect.length)
    }
    if (skipTags.indexOf(zltp.nodeName.toLowerCase()) > -1 && !zltp.classList.contains(('v'))) continue
    let parent = paragraphs[zltp.parentIndex]

    if (parent && (isTableCell(zltp) || isTableCell(parent)) ) {
      let te = isTable(parent)
      if (te && isMultiColumnTable(te)) {
        let firstIndex = 0
        for (let t=0; t < pcnt; t++) {
          let el = paragraphs[t]
          if (el === te) firstIndex = t+1
        }
        pageLoutVect.push(pageLayout(0, firstPar+par, true, textOffs+getTextOffs(zltp), par))
        setId(parent, pageLoutVect.length)
        let pCount = getParagraphs(te.children).length
        par = firstIndex + pCount - 1
        textLeng = -1
        for (let p=0; p < pCount; p++) {
          zltp = paragraphs[firstIndex + p]
          zltp.inTable = 1
        }
        continue
      }
    }
    let  tl = getTotalSize(zltp, 0)

    if (textLeng === -1) {
      pageLoutVect.push(pageLayout(0, firstPar+par, false, textOffs+getTextOffs(zltp), par))
      setId(zltp, pageLoutVect.length)
      textLeng = tl
      continue
    }
    if (textLeng + tl < 2048) {
      textLeng += tl
      continue
    }

    pageLoutVect.push(pageLayout(0, firstPar+par, false, textOffs+getTextOffs(zltp), par))
    setId(zltp, pageLoutVect.length)
    textLeng = tl
  }
  sectionMap.pages = pageLoutVect
  sectionMap.lst_page = pageLoutVect.length
  sectionMap.storages = storages
  return sectionMap
}


// WEBPACK FOOTER //
// ./src/utilities/otherUtilities.js